exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".error.error-4 .error-title {\n  font-size: 8.7rem !important;\n}\n.error.error-4 .error-subtitle {\n  font-size: 4.5rem !important;\n}\n\n@media (min-width: 768px) {\n  .error.error-4 .error-title {\n    font-size: 15.7rem !important;\n  }\n  .error.error-4 .error-subtitle {\n    font-size: 9.5rem !important;\n  }\n}", ""]);

